import { useTranslation } from "react-i18next";
import type { RagSource } from "../api/ragApi";

interface RagSourceChipProps {
  source: RagSource;
}

const RagSourceChip = ({ source }: RagSourceChipProps) => {
  const { t } = useTranslation();

  // Office formats carry where the chunk came from; PDF, TXT and DOCX carry
  // nothing and the chip stays exactly as it was.
  let provenance: string | null = null;
  if (source.metadata?.sheet) {
    provenance = t("pages.agents.chat.sourceSheet", { name: source.metadata.sheet });
  } else if (source.metadata?.slide) {
    provenance = t("pages.agents.chat.sourceSlide", { number: source.metadata.slide });
  }

  return (
    <div
      className="inline-flex items-center gap-1 px-2 py-1 rounded bg-gray-100 text-xs text-gray-600 hover:bg-gray-200 transition-colors cursor-default"
      title={source.preview}
    >
      <span className="text-gray-400">📄</span>
      <span>{source.filename}</span>
      {provenance && <span className="text-gray-400">{provenance}</span>}
    </div>
  );
};

export default RagSourceChip;
